import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { VisaDiscountRateCreateDto, VisaDiscountRateUpdateDto } from '../dtos/visa-discount-rate/VisaDiscountRateDto';

@Injectable({
  providedIn: 'root',
})
export class VisaDiscountRateService {
  private apiUrl = `${environment.apiUrl}/visaDiscountRate`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<any> {
    return this.http.get<any>(this.apiUrl);
  }

  getByvisaPriceDefinition(visaPriceDefinitionId: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${visaPriceDefinitionId}`);
  }

  create(discountRate: VisaDiscountRateCreateDto): Observable<any> {
    return this.http.post<any>(this.apiUrl, discountRate);
  }

  update(id: number, discountRate: VisaDiscountRateUpdateDto): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${id}`, discountRate);
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`);
  }
}
